/**
 * Branchement SSO Chat sur suite-shared (avant / avec le shell React).
 * CLEAR_CACHE hub → installChatCacheGuard (pas installSuiteClearCacheListener : évite double reload).
 */
import { getSuiteHubWhoamiUrl, isChatStandalone } from "./apiBase";
import { isChatGuestJoin } from "./lib/guestToken";
import { installChatCacheGuard } from "./lib/cache/chatSwBootstrap";
import {
  clearChatLocalLogoutMark,
  isChatEmbeddedInHub,
  isChatLocalLogout,
  readStoredSuiteUserId,
} from "./suiteSession";

function mountChatSharedModals(): void {
  if (typeof window.suiteAuthModalMount === "function") {
    window.suiteAuthModalMount({
      appName: "Chat",
    });
  }
  if (typeof window.suiteForbiddenModalMount === "function") {
    window.suiteForbiddenModalMount({ appName: "Chat" });
  }
  if (typeof window.suiteLogoutModalsMount === "function") {
    window.suiteLogoutModalsMount({ appName: "Chat" });
  }
}

function runChatSharedInit(): void {
  if (isChatGuestJoin()) return;
  mountChatSharedModals();
  installChatCacheGuard();

  if (typeof window.installSuiteAuthPopup !== "function") {
    console.error("Chat : kit suite-shared introuvable (installSuiteAuthPopup)");
    return;
  }

  if (isChatLocalLogout()) {
    window.showSuiteAuthModal?.(undefined, { autoReconnect: false });
  }

  window.installSuiteAuthPopup({
    redirect: "chat",
    isConnected: () => window.__chatIsConnected?.() ?? false,
    onAuthenticated: async (userId) => {
      await window.__chatOnAuthenticated?.(userId);
    },
    onSessionLost: () => {
      window.__chatOnSessionLost?.(null);
    },
    patchFetch: false,
  });

  window.__suiteOnManualConnectClick = () => {
    clearChatLocalLogoutMark();
  };

  // Comme Mail : pas de poll whoami en PWA standalone.
  if (isChatStandalone()) {
    return;
  }

  const whoamiUrl = getSuiteHubWhoamiUrl();
  if (whoamiUrl && typeof window.installSuiteHubSessionWatch === "function") {
    window.installSuiteHubSessionWatch({
      whoamiUrl,
      isEmbeddedInHub: isChatEmbeddedInHub,
      shouldSkipCheck: isChatLocalLogout,
      hasStoredIdentity: () => Boolean(readStoredSuiteUserId()) && !isChatLocalLogout(),
      isAppSessionActive: () => window.__chatSessionVerified === true,
      onSessionLost: () => {
        window.__chatOnSessionLost?.(null);
      },
    });
  }
}

if (window.__SUITE_SHARED_READY__) {
  runChatSharedInit();
} else {
  document.addEventListener("suiteSharedReady", runChatSharedInit, { once: true });
  document.addEventListener("suiteSharedFailed", () => {
    console.error("Chat : échec chargement suite-shared");
  });
}
